'use client';

import clarity from '@microsoft/clarity';
import { useEffect } from 'react';

export default function Clarity() {
    useEffect(() => {
        const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
        if (projectId) {
            clarity.init(projectId);
        }
    }, []);

    return null;
}
